<template>
  <div class="search-section">
    <div class="divider">
      <h4>بحث في الإيداع البنكي أو ال ATM</h4>
      <hr
        role="separator"
        aria-orientation="horizontal"
        class="v-divider theme--dark"
      />
    </div>
    <div class="row">
      <div class="col-lg-3 py-0">
        <div class="input_wrapper top_label auto_complete">
          <label class="form-label"> حساب المؤسسة</label>
          <v-autocomplete
            v-model="searchData.enterprice"
            :search-input.sync="searchOptions.search_enterprices"
            :items="enterprices"
            @change="$emit('filterTable', searchData)"
            item-text="name"
            return-object
            @input="addEnterpriceData(searchData.enterprice)"
            :hide-no-data="!enterprices"
            dense
          ></v-autocomplete>
          <button class="button_style_1 load_inline" v-if="load_enterprices">
            <span class="btn_loader"></span>
          </button>
        </div>
      </div>

      <div class="col-lg-3 py-0">
        <div class="input_wrapper top_label auto_complete">
          <label class="form-label"> إسم العميل</label>
          <v-autocomplete
            v-model="searchData.user"
            :search-input.sync="searchOptions.search_users"
            :items="users"
            @change="$emit('filterTable', searchData)"
            item-text="name"
            return-object
            @input="addUserData(searchData.user)"
            :hide-no-data="!users"
            dense
          ></v-autocomplete>
          <button class="button_style_1 load_inline" v-if="load_users">
            <span class="btn_loader"></span>
          </button>
        </div>
      </div>
      <div class="col-lg-2 py-0">
        <div class="input_wrapper top_label mb-3">
          <label class="form-label"> الخزنة </label>
          <multiselect
            v-model="searchData.lock"
            :options="searchOptions.locks"
            label="name"
            track-by="id"
            placeholder=" "
            :searchable="true"
            :allow-empty="true"
            :show-labels="false"
            @input="chooseLock(searchData.lock), $emit('filterTable', searchData)"
          >
          </multiselect>
        </div>
      </div>
      <div class="col-lg-2 py-0">
        <div class="input_wrapper top_label date_input">
          <label class="form-label">من</label>
          <v-menu
            ref="to_date_menu"
            v-model="searchOptions.from_date_menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="searchData.from"
                label="Date"
                prepend-icon="mdi-calendar"
                readonly
                clearable
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="searchData.from"
              @input="searchOptions.from_date_menu = false"
              no-title
              scrollable
            >
            </v-date-picker>
          </v-menu>
        </div>
      </div>
      <div class="col-lg-2 py-0">
        <div class="input_wrapper top_label date_input">
          <label class="form-label">إلي</label>
          <v-menu
            ref="to_date_menu"
            v-model="searchOptions.to_date_menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="searchData.to"
                label="Date"
                prepend-icon="mdi-calendar"
                readonly
                clearable
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="searchData.to"
              @input="searchOptions.to_date_menu = false"
              no-title
              scrollable
            >
            </v-date-picker>
          </v-menu>
        </div>
      </div>
      <div class="col-lg-12 text-center py-0">
        <button
          class="button_style_1"
          @click="$emit('filterTable', searchData)"
        >
          بحث
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      load_users: false,
      load_enterprices: false,

      // search
      searchData: {
        user: null,
        userId: null,
        userName: null,
        enterprice: null,
        enterpriceId: null,
        enterpriceName: null,
        lock: null,
        lockId: null,
        from: new Date().toISOString().slice(0, 10),
        to: new Date().toISOString().slice(0, 10),
      },
      searchOptions: {
        locks: [],
        search_users: "",
        search_enterprices: "",
        from_date_menu: false,
        to_date_menu: false,
      },
      users: null,
      enterprices: null,
    };
  },
  watch: {
    [`searchOptions.search_users`](newVal, oldVal) {
      if (!newVal || newVal.length < 3) {
        this.users = null;
      } else {
        if (!newVal & (oldVal == "")) {
          this.get_filterd_users(oldVal);
        } else if ((newVal == "") & (oldVal != "")) {
          this.get_filterd_users(newVal);
        } else {
          this.get_filterd_users(newVal);
        }
      }
    },

    [`searchOptions.search_enterprices`](newVal, oldVal) {
      if (!newVal || newVal.length < 3) {
        this.enterprices = null;
      } else {
        if (!newVal & (oldVal == "")) {
          this.get_filterd_enterprices(oldVal);
        } else if ((newVal == "") & (oldVal != "")) {
          this.get_filterd_enterprices(newVal);
        } else {
          this.get_filterd_enterprices(newVal);
        }
      }
    },
  },
  methods: {
    // get_filterd_users
    get_filterd_users(keyword) {
      this.load_users = true;
      this.$axios({
        method: "GET",
        url: `client/customer/search?keyword=${keyword}`,
      })
        .then((res) => {
          this.users = res.data.data;
          this.load_users = false;
        })
        .catch((err) => {
          this.load_users = false;
        });
    },
    getSafes() {
      // START:: GET SAFES
      this.$axios({
        method: "GET",
        url: `client/wallet`,
      })
        .then((res) => {
          this.searchOptions.locks = res.data.data;
        })
        .catch((err) => {
          console.log(err.response.data);
        });
      // END:: GET SAFES
    },
    // get_filterd_enterprices
    get_filterd_enterprices(keyword) {
      this.load_enterprices = true;
      this.$axios({
        method: "GET",
        url: `help/accounts?keyword=${keyword}`,
      })
        .then((res) => {
          this.enterprices = res.data.data.map((item) => {
            return {
              id: item.id,
              name: item.name,
            };
          });
          this.load_enterprices = false;
        })
        .catch((err) => {
          this.load_enterprices = false;
        });
    },
    addUserData(item) {
      if (this.searchData.user) {
        this.searchData.userId = item.id;
        this.searchData.userName = item.name;
      } else {
        this.searchData.userId = null;
        this.searchData.userName = null;
      }
    },
    addEnterpriceData(item) {
      if (this.searchData.enterprice) {
        this.searchData.enterpriceId = item.id;
        this.searchData.enterpriceName = item.name;
      } else {
        this.searchData.enterpriceId = null;
        this.searchData.enterpriceName = null;
      }
    },
    chooseLock(item) {
      if (this.searchData.lock) {
        this.searchData.lockId = item.id;
      } else {
        this.searchData.lockId = null;
      }
    },
  },
  created() {
    this.getSafes();
  },
};
</script>

<style lang="scss">
.search-section .load_inline {
  width: 30px !important;
  height: 25px !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  padding: 0 !important;
  left: 1px;
  position: absolute !important;
  background: transparent !important;
  margin: 0 !important;

  span {
    right: 0 !important;
    left: 0 !important;
    margin: auto !important;
    border-top: 3px solid var(--mainColor-2) !important;
    border-right: 3px solid transparent !important;
  }
}
</style>

